/**
 * File Type Icons
 * 
 * Icons representing different file types and document formats.
 * Used for file listings, document viewers, and upload interfaces.
 * 
 * Used by: Document lists, file upload, knowledge base, quick look
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFile as fadFile,
  faFileImage as fadFileImage,
  faFileLines as fadFileLines,
  faFilePdf as fadFilePdf,
  faFileZip as fadFileZip,
  faFileExcel as fadFileExcel,
  faFileWord as fadFileWord,
  faFileDoc as fadFileDoc,
  faFileMusic as fadFileMusic,
  faFileCsv as fadFileCsv,
  faFilePowerpoint as fadFilePowerpoint,
  faFileVideo as fadFileVideo,
  faFilePen as fadFilePen,
  faFileBinary as fadFileBinary,
  faFileCircleInfo as fadFileCircleInfo,
  faFileSignature as fadFileSignature,
  faFileCode as fadFileCode,
  faFileInvoice as fadFileInvoice,
  faFileCheck as fadFileCheck,
  faFileMedical as fadFileMedical,
  faFileUser as fadFileUser,
  faFileEdit as fadFileEdit,
  faFileImport as fadFileImport,
  faFileContract as fadFileContract,
  faFileInvoiceDollar as fadFileInvoiceDollar,
  faFileMagnifyingGlass as fadFileMagnifyingGlass,
  faFiles as fadFiles,
  faFilesMedical as fadFilesMedical,
  faFileLock as fadFileLock,
  faClipboardCheck as fadClipboardCheck,
  faFileArrowDown as fadFileArrowDown,
  faFileChartColumn as fadFileChartColumn,
  faEllipsisVertical as fadEllipsisVertical,
} from "@fortawesome/pro-duotone-svg-icons";

import {
  faFileBinary as fasFileBinary,
  faBinarySlash as fasBinarySlash,
} from "@fortawesome/pro-solid-svg-icons";

import {
  faFileLock as fatFileLock,
} from "@fortawesome/pro-thin-svg-icons";

export const loadFileIcons = () => {
  // Duotone file icons
  library.add(
    fadFile,
    fadFileImage,
    fadFileLines,
    fadFilePdf,
    fadFileZip,
    fadFileExcel,
    fadFileWord,
    fadFileDoc,
    fadFileMusic,
    fadFileCsv,
    fadFilePowerpoint,
    fadFileVideo,
    fadFilePen,
    fadFileBinary,
    fadFileCircleInfo,
    fadFileSignature,
    fadFileCode,
    fadFileInvoice,
    fadFileCheck,
    fadFileMedical,
    fadFileUser,
    fadFileEdit,
    fadFileImport,
    fadFileContract,
    fadFileInvoiceDollar,
    fadFileMagnifyingGlass,
    fadFiles,
    fadFilesMedical,
    fadFileLock,
    fadClipboardCheck,
    fadFileArrowDown,
    fadFileChartColumn,
    fadEllipsisVertical,
  );

  // Solid file icons
  library.add(
    fasFileBinary,
    fasBinarySlash,
  );

  // Thin file icons
  library.add(
    fatFileLock,
  );
};
